const parseError = (error) => {
  // Aborted requests must not surface as network/connectivity failures.
  if (
    error?.code === "ERR_CANCELED" ||
    error?.name === "CanceledError" ||
    error?.name === "AbortError" ||
    error?.message === "canceled" ||
    error?.message === "Request aborted" ||
    (typeof error?.__CANCEL__ !== "undefined" && error.__CANCEL__)
  ) {
    const err = new Error("Request cancelled");
    err.isCancelled = true;
    err.code = "ERR_CANCELED";
    throw err;
  }

  let message = "";
  if (error.response) {
    const data = error.response.data;
    message =
      (typeof data === "object" && data !== null && (data.error ?? data.message)) ||
      (typeof data === "string" && data.length < 500 ? data : "") ||
      "";
    if (!message && error.response.status >= 400) {
      message = error.response.status === 422
        ? "Validation failed. Please check your input."
        : "Something went wrong. Please try again.";
    }
    // Log 404 errors to console with detailed information
    if (error.response.status === 404) {
      console.error("🔴 404 Error:", {
        status: 404,
        statusText: error.response.statusText,
        url: error.config?.url || error.config?.baseURL || "Unknown URL",
        method: error.config?.method?.toUpperCase() || "Unknown",
        message: message || "Not Found",
        data: error.response.data,
        fullError: error,
      });
    }
    // Preserve response so callers can read status and validation errors (e.g. 422 errors)
    const err = new Error(message);
    err.response = error.response;
    throw err;
  } else if (error.request) {
    if (error.code === "ECONNABORTED") {
      message = "The request timed out. Please try again.";
    } else if (error.message === "Network Error") {
      message =
        "Could not read the API response (network error, or the server returned an error without CORS headers). Check DevTools → Network for status codes such as 502.";
    } else {
      message = "No Internet Connectivity!";
    }
    throw new Error(message);
  } else {
    message = error.message || "Something went wrong.";
  }
  throw new Error(message || "Something went wrong.");
};

export default parseError;
